import { Pipe, PipeTransform } from '@angular/core';

import { matchesPrefix } from '@app/shared/components/navbar/is-child-active.pipe';
import { ENavbarItemType, NavbarGroup } from '@app/shared/components/under-ui-header/types/navbar-item.type';

@Pipe({
  name: 'isParentActive',
  standalone: true,
  pure: true,
})
export class IsParentActivePipe implements PipeTransform {
  transform(group: NavbarGroup, currentUrl: string): boolean {
    return group.children.some(
      child => child.type === ENavbarItemType.Link && matchesPrefix(currentUrl, child.activePath ?? child.path),
    );
  }
}
